/** 随机整数 */
const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};

/** 随机日期 */
const getRandomDate = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    throw new Error("无效的日期格式，请使用YYYY-MM-DD格式");
  }

  if (start > end) {
    throw new Error("开始日期不能晚于结束日期");
  }

  // 生成随机时间戳（毫秒）
  const randomTimestamp = start.getTime() + Math.random() * (end.getTime() - start.getTime());

  // 创建新日期对象
  const randomDate = new Date(randomTimestamp);

  // 格式化为YYYY-MM-DD
  const year = randomDate.getFullYear();
  const month = String(randomDate.getMonth() + 1).padStart(2, "0");
  const day = String(randomDate.getDate()).padStart(2, "0");

  return new Date(year, month, day);
};

export default {
  /** 随机整数 */
  getRandomInt: (min, max) => getRandomInt(min, max),
  /** 随机日期 */
  getRandomDate: (startDate, endDate) => getRandomDate(startDate, endDate),
  /** 生成任务数据
   * @param count 生成的条数
   * @param startDate 随机开始时间范围
   * @param endDate 随机开始时间范围
   */
  getTaskData(count, startDate, endDate) {
    var task = [];
    for (var i = 1; i <= count; i++) {
      const randomDate = getRandomDate(startDate, endDate);
      task.push({
        id: i,
        text: "任务" + i,
        start_date: randomDate,
        unit: "天",
        duration: getRandomInt(2, 6),
        progress: Math.random().toFixed(1),
      });
    }
    return task;
  },
};
